import {
  Intent,
  Navbar,
  NavbarGroup,
  Alignment,
  NavbarHeading,
  NavbarDivider,
  Button,
  Popover,
  Menu,
  PopoverInteractionKind,
  MenuItem,
} from '@blueprintjs/core';
import * as React from 'react';
import { useHistory } from 'react-router';

import { buildPathForLocation, getActiveLocationId } from 'vms/app/configureApp';
import { useAppDispatch, useAppSelector } from 'vms/app/hooks';
import AnchorButton from 'vms/common/components/AnchorButton';
import { logout } from 'vms/features/accounts/actions';
import { useCurrentUser } from 'vms/features/accounts/queries';
import LocationSelect from 'vms/features/locations/LocationSelect';
import RecentVehicles from 'vms/features/vehicles/RecentVehicles';
import { selectVehicleInWork } from 'vms/features/vehicles/selectors';

export function Nav() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const user = useCurrentUser();
  const vehicleInWork = useAppSelector(selectVehicleInWork);
  const [isProfileOpen, setIsProfileOpen] = React.useState(false);
  const [logoutInProgress, setLogoutInProgress] = React.useState(false);
  const [isWatchHistoryOpen, setIsWatchHistoryOpen] = React.useState(false);

  const handleLogout = () => {
    setLogoutInProgress(true);
    dispatch(logout());
  };

  const handleLocationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const nextLocationId = event.target.value || null;
    const basePath = history.location.pathname || '/';
    const search = window.location.search;
    const hash = window.location.hash;
    const nextPath = buildPathForLocation(basePath, nextLocationId);
    const nextUrl = `${nextPath}${search}${hash}`;
    const currentUrl = `${window.location.pathname}${search}${hash}`;
    if (nextUrl === currentUrl) {
      return;
    }
    window.location.assign(nextUrl);
  };

  if (!user) {
    return null;
  }
  const recentVehicles = RecentVehicles.getHistory();
  const activeLocationId = getActiveLocationId() || '';
  return (
    <Navbar>
      <NavbarGroup align={Alignment.START}>
        <NavbarHeading>MagiLoop VMS</NavbarHeading>
        <div style={{ marginLeft: 12 }}>
          <LocationSelect
            name="navbar-location"
            selected={activeLocationId}
            onChange={handleLocationChange}
          />
        </div>
      </NavbarGroup>
      <NavbarGroup align={Alignment.END}>
        {vehicleInWork && (
          <Button
            icon="wrench"
            intent={Intent.WARNING}
            onClick={() => history.push(`/vehicles/${vehicleInWork.vehicle}/`)}
          />
        )}
        <NavbarDivider />
        <AnchorButton variant="minimal" icon="home" text="Home" to="/" />
        <Popover
          isOpen={isWatchHistoryOpen}
          onInteraction={setIsWatchHistoryOpen}
          canEscapeKeyClose={true}
          interactionKind={PopoverInteractionKind.CLICK}
          content={
            <Menu>
              {recentVehicles.length ? (
                recentVehicles.map((v) => (
                  <MenuItem
                    key={v.id}
                    text={`${v.make} ${v.model}`}
                    onClick={() => history.push(`/vehicles/${v.id}/`)}
                  />
                ))
              ) : (
                <MenuItem text="Empty" disabled={true} />
              )}
            </Menu>
          }
        >
          <Button variant="minimal" icon="history">
            Recent Vehicles
          </Button>
        </Popover>
        <Popover
          isOpen={isProfileOpen}
          onInteraction={setIsProfileOpen}
          canEscapeKeyClose={true}
          interactionKind={PopoverInteractionKind.CLICK}
          content={
            <Menu>
              <MenuItem
                disabled={logoutInProgress}
                icon="log-out"
                text="Logout"
                onClick={handleLogout}
              />
            </Menu>
          }
        >
          <Button variant="minimal" icon="user">
            {user.name}
          </Button>
        </Popover>
      </NavbarGroup>
    </Navbar>
  );
}

export default Nav;
